import React, { useEffect, useState } from 'react';
import { Navigation } from '../components/Navigation';
import { ChevronDownIcon } from 'lucide-react';
export function PricingServices() {
  const [activeSection, setActiveSection] = useState('neuromodulators');
  const [isOpen, setIsOpen] = useState(false);
  const sections = [{
    id: 'neuromodulators',
    label: 'Neuromodulators'
  }, {
    id: 'fillers',
    label: 'Fillers'
  }, {
    id: 'pdo-threads',
    label: 'PDO Threads'
  }, {
    id: 'biostimulators',
    label: 'Biostimulators'
  }, {
    id: 'microneedling',
    label: 'Microneedling'
  }, {
    id: 'peels',
    label: 'Medical Peels'
  }, {
    id: 'mesotherapy',
    label: 'Mesotherapy'
  }, {
    id: 'weight-loss',
    label: 'Weight Loss'
  }, {
    id: 'lasers',
    label: 'Lasers & RF'
  }];
  useEffect(() => {
    const handleScroll = () => {
      let currentSection = sections[0].id;
      sections.forEach(({
        id
      }) => {
        const element = document.getElementById(id);
        if (element) {
          const rect = element.getBoundingClientRect();
          if (rect.top <= 150) {
            currentSection = id;
          }
        }
      });
      setActiveSection(currentSection);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const handleSectionClick = (sectionId: string) => {
    setActiveSection(sectionId);
    setIsOpen(false);
    const element = document.getElementById(sectionId);
    if (element) {
      const offset = 96;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };
  return <div className="min-h-screen bg-white" data-id="element-411">
      <Navigation data-id="element-412" />
      {/* Hero Section */}
      <div className="pt-32 pb-16 bg-[rgba(250,179,212,0.1)]" data-id="element-413">
        <div className="max-w-4xl mx-auto px-6 text-center" data-id="element-414">
          <h1 className="font-heading font-light text-5xl md:text-6xl mb-6 tracking-wide" data-id="element-415">
            Services & Pricing
          </h1>
          <p className="font-body text-xl tracking-wider uppercase" data-id="element-416">
            Medical aesthetics treatments tailored to your needs
          </p>
        </div>
      </div>
      {/* Services Navigation */}
      <nav className="sticky top-20 bg-white border-b z-30" data-id="element-417">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-4" data-id="element-418">
          {/* Mobile Dropdown */}
          <div className="md:hidden" data-id="element-419">
            <button onClick={() => setIsOpen(!isOpen)} className="w-full flex items-center justify-between px-4 py-2 bg-[rgba(250,179,212,0.1)] rounded-lg" data-id="element-420">
              <span className="font-medium text-xs" data-id="element-421">
                {sections.find(s => s.id === activeSection)?.label}
              </span>
              <ChevronDownIcon className={`w-4 h-4 transition-transform ${isOpen ? 'rotate-180' : ''}`} data-id="element-422" />
            </button>
            {isOpen && <div className="absolute left-0 right-0 mt-2 px-4 py-2 bg-white border-b shadow-lg" data-id="element-423">
                <div className="max-w-7xl mx-auto" data-id="element-424">
                  {sections.map(section => <button key={section.id} className={`block w-full text-left py-2 px-3 text-xs relative ${activeSection === section.id ? 'text-black bg-[rgba(250,179,212,0.1)] border-l-2 border-[rgba(250,179,212,0.5)]' : 'text-gray-600'}`} onClick={() => handleSectionClick(section.id)} data-id="element-425">
                      {section.label}
                    </button>)}
                </div>
              </div>}
          </div>
          {/* Desktop Navigation */}
          <div className="hidden md:block" data-id="element-426">
            <div className="flex justify-center" data-id="element-427">
              <div className="flex gap-4 lg:gap-6 font-body text-[11px] lg:text-xs tracking-wider uppercase whitespace-nowrap" data-id="element-428">
                {sections.map(section => <button key={section.id} className={`relative py-2 text-gray-600 hover:text-black transition-colors ${activeSection === section.id ? 'text-black font-medium' : ''}`} onClick={() => handleSectionClick(section.id)} data-id="element-429">
                    {section.label}
                    {activeSection === section.id && <span className="absolute bottom-0 left-0 w-full h-0.5 bg-[rgba(250,179,212,0.5)] transition-all duration-300 ease-out" data-id="element-430" />}
                  </button>)}
              </div>
            </div>
          </div>
        </div>
      </nav>
      {/* Main Content */}
      <main className="max-w-4xl mx-auto px-6 py-16" data-id="element-431">
        {/* Neuromodulators */}
        <section id="neuromodulators" className="mb-24 scroll-mt-40" data-id="element-432">
          <h2 className="font-heading font-light text-2xl mb-8 tracking-wide" data-id="element-433">
            Neuromodulators
          </h2>
          <div className="font-body space-y-4" data-id="element-434">
            <ul className="list-disc pl-5 space-y-4" data-id="element-435">
              <li data-id="element-436">
                <strong data-id="element-437">BnTx</strong> (botulinum neurotoxin) has been safely
                used for over 50 years to relax muscles.
              </li>
              <li data-id="element-438">
                Injected into facial muscles to smooth unwanted lines—like frown
                lines or RBF.
              </li>
              <li data-id="element-439">
                My preferred option: <strong data-id="element-440">Xeomin by Merz</strong> —
                preservative-free and clean.
              </li>
              <li data-id="element-441">Results in 1–5 days, lasting 4–6 months.</li>
            </ul>
            <div className="bg-[rgba(250,179,212,0.1)] p-6 rounded-lg my-6" data-id="element-442">
              <p className="font-semibold" data-id="element-443">
                Average treatment: <strong data-id="element-444">30–45 units at $11/unit</strong>
              </p>
            </div>
            <ul className="list-disc pl-5" data-id="element-445"></ul>
          </div>
        </section>
        {/* Fillers */}
        <section id="fillers" className="mb-24 scroll-mt-40" data-id="element-446">
          <h2 className="font-heading font-light text-2xl mb-8 tracking-wide" data-id="element-447">
            Fillers
          </h2>
          <div className="font-body space-y-4" data-id="element-448">
            <ul className="list-disc pl-5 space-y-4" data-id="element-449">
              <li data-id="element-450">
                I use <strong data-id="element-451">biocompatible fillers</strong> made from
                hyaluronic acid or calcium hydroxylapatite.
              </li>
              <li data-id="element-452">
                Used to enhance structure (cheeks) or smooth deep lines (lower
                face).
              </li>
              <li data-id="element-453">Most contain lidocaine for comfort.</li>
              <li data-id="element-454">Bruising is common near the mouth or eyes—plan ahead.</li>
              <li data-id="element-455">
                <strong data-id="element-456">Radiesse</strong> (calcium hydroxylapatite) stimulates
                collagen and adds fullness.
              </li>
              <li data-id="element-457">Ideal for face, neck, chest, and hands.</li>
              <li data-id="element-458">Fast treatment, minimal downtime.</li>
            </ul>
            <div className="bg-[rgba(250,179,212,0.1)] p-6 rounded-lg my-6" data-id="element-459">
              <p className="font-semibold" data-id="element-460">
                <strong data-id="element-461">Cost</strong>: $185–$600 per syringe (pay only for what
                you use, except Radiesse)
              </p>
            </div>
          </div>
        </section>
        {/* PDO Threads */}
        <section id="pdo-threads" className="mb-24 scroll-mt-40" data-id="element-462">
          <h2 className="font-heading font-light text-2xl mb-8 tracking-wide" data-id="element-463">
            PDO Threads
          </h2>
          <div className="font-body space-y-4" data-id="element-464">
            <ul className="list-disc pl-5 space-y-4" data-id="element-465">
              <li data-id="element-466">
                Made from <strong data-id="element-467">polydioxanone</strong>, these threads
                stimulate collagen and tighten skin.
              </li>
              <li data-id="element-468">
                They dissolve in 4–6 months, leaving firmer, smoother skin.
              </li>
              <li data-id="element-469">
                Thread types:{' '}
                <strong data-id="element-470">
                  lifting (barbs), volumizing (fill), smoothing (monos)
                </strong>
                .
              </li>
              <li data-id="element-471">Lip threads require oral anesthetic; bruising possible.</li>
              <li data-id="element-472">Advance consult and supplement prep required.</li>
            </ul>
            <div className="bg-[rgba(250,179,212,0.1)] p-6 rounded-lg my-6" data-id="element-473">
              <p className="font-semibold" data-id="element-474">
                <strong data-id="element-475">Cost</strong>: $800–$1200 for face/jawline lift
              </p>
            </div>
          </div>
        </section>
        {/* Biostimulators */}
        <section id="biostimulators" className="mb-24 scroll-mt-40" data-id="element-476">
          <h2 className="font-heading font-light text-2xl mb-8 tracking-wide" data-id="element-477">
            Biostimulators
          </h2>
          <div className="font-body space-y-4" data-id="element-478">
            <ul className="list-disc pl-5 space-y-4" data-id="element-479">
              <li data-id="element-480">
                <strong data-id="element-481">Radiesse Wash</strong>: thinned for smooth, even spread
                under skin. Best for aging, sagging skin support.
              </li>
              <li data-id="element-482">
                <strong data-id="element-483">GHK CU Cream</strong>: copper peptides to tighten and
                repair the skin barrier.
              </li>
              <li data-id="element-484">
                <strong data-id="element-485">Topical Estrogen</strong>: restores moisture and
                collagen to plump thinning skin.
              </li>
            </ul>
          </div>
        </section>
        {/* Radiesse */}
        <section id="radiesse" className="mb-24 scroll-mt-40" data-id="element-486">
          <h2 className="font-heading font-light text-2xl mb-8 tracking-wide" data-id="element-487">
            Radiesse Bio-Rejuvenation
          </h2>
          <div className="font-body space-y-4" data-id="element-488">
            <ul className="list-disc pl-5 space-y-4" data-id="element-489">
              <li data-id="element-490">
                <strong data-id="element-491">Radiesse Wash</strong>: thinned for smooth, even spread
                under skin.
              </li>
              <li data-id="element-492">Best for aging, sagging skin support.</li>
            </ul>
          </div>
        </section>
        {/* Microneedling */}
        <section id="microneedling" className="mb-24 scroll-mt-40" data-id="element-493">
          <h2 className="font-heading font-light text-2xl mb-8 tracking-wide" data-id="element-494">
            Microneedling with Stem Cells
          </h2>
          <div className="font-body space-y-4" data-id="element-495">
            <ul className="list-disc pl-5 space-y-4" data-id="element-496">
              <li data-id="element-497">
                <strong data-id="element-498">Nuova pen</strong> is 3x more effective than standard
                microneedling.
              </li>
              <li data-id="element-499">
                Combined with stem cells + hyaluronic acid for a "wow" effect.
              </li>
              <li data-id="element-500">Treats melasma, acne scars, dull or aging skin.</li>
              <li data-id="element-501">Quick recovery: 20 mins numbing + 24 hrs redness.</li>
              <li data-id="element-502">Results last 1–2 months.</li>
            </ul>
            <div className="bg-[rgba(250,179,212,0.1)] p-6 rounded-lg my-6" data-id="element-503">
              <p className="font-semibold" data-id="element-504">
                <strong data-id="element-505">Intro price</strong>: $300 (next 6 months only)
              </p>
            </div>
          </div>
        </section>
        {/* Medical Grade Peels */}
        <section id="peels" className="mb-24 scroll-mt-40" data-id="element-506">
          <h2 className="font-heading font-light text-2xl mb-8 tracking-wide" data-id="element-507">
            Medical Grade Peels
          </h2>
          <div className="font-body space-y-4" data-id="element-508">
            <ul className="list-disc pl-5 space-y-4" data-id="element-509">
              <li data-id="element-510">
                Improve skin cell turnover, fade sun spots, rosacea & acne
                scars.
              </li>
              <li data-id="element-511">Work best in a series or combined with other treatments.</li>
              <li data-id="element-512">
                <strong data-id="element-513">ViPeel</strong> is self-neutralizing with gentle peeling
                on days 3–4.
              </li>
              <li data-id="element-514">Less downtime, great results.</li>
            </ul>
          </div>
        </section>
        {/* Mesotherapy */}
        <section id="mesotherapy" className="mb-24 scroll-mt-40" data-id="element-515">
          <h2 className="font-heading font-light text-2xl mb-8 tracking-wide" data-id="element-516">
            Mesotherapy (Fat Dissolving)
          </h2>
          <div className="font-body space-y-4" data-id="element-517">
            <ul className="list-disc pl-5 space-y-4" data-id="element-518">
              <li data-id="element-519">
                <strong data-id="element-520">PCDC</strong> is a fat-dissolving injection (PC + DC
                compounds).
              </li>
              <li data-id="element-521">Targets small fat areas on face or body.</li>
              <li data-id="element-522">Best done in a series, spaced 4–6 weeks apart.</li>
              <li data-id="element-523">
                Expect mild bruising and heat — bring cold packs for large
                areas.
              </li>
            </ul>
          </div>
        </section>
        {/* Weight Loss */}
        <section id="weight-loss" className="mb-24 scroll-mt-40" data-id="element-524">
          <h2 className="font-heading font-light text-2xl mb-8 tracking-wide" data-id="element-525">
            Weight Loss
          </h2>
          <h3 className="text-xl mb-4 font-semibold" data-id="element-526">Semaglutide Injections</h3>
          <div className="font-body space-y-4" data-id="element-527">
            <ul className="list-disc pl-5 space-y-4" data-id="element-528">
              <li data-id="element-529">Weekly at-home treatment</li>
              <li data-id="element-530">Prescribing for the last 3 years</li>
            </ul>
            <div className="mt-6 space-y-4" data-id="element-531">
              <div data-id="element-532">
                <h4 className="font-semibold mb-2" data-id="element-533">
                  Semaglutide Use 1: Micro-dose for menopause belly
                </h4>
              </div>
              <div data-id="element-534">
                <h4 className="font-semibold mb-2" data-id="element-535">
                  Semaglutide Use 2: Titrated dose for general weight-loss
                </h4>
              </div>
            </div>
          </div>
        </section>
        {/* Lasers & RF */}
        <section id="lasers" className="mb-24 scroll-mt-40" data-id="element-536">
          <h2 className="font-heading font-light text-2xl mb-8 tracking-wide" data-id="element-537">
            Lasers & Radiofrequency
          </h2>
          <h3 className="text-2xl mb-4 font-semibold" data-id="element-538">Phoenix Location Only</h3>
          <div className="font-body space-y-4 mb-8" data-id="element-539">
            <ul className="list-disc pl-5" data-id="element-540">
              <li data-id="element-541">
                <strong data-id="element-542">Clearlift Nd YAG Laser</strong>: no downtime, evens
                tone, treats rosacea/acne/loose skin.
              </li>
            </ul>
          </div>
          <h3 className="text-2xl mb-4 font-semibold" data-id="element-543">Off-Site Treatments</h3>
          <div className="font-body space-y-4" data-id="element-544">
            <ul className="list-disc pl-5 space-y-4" data-id="element-545">
              <li data-id="element-546">
                <strong data-id="element-547">Juvashape RF</strong>: skin tightening + fat reduction
                using heat.
              </li>
              <li data-id="element-548">
                <strong data-id="element-549">Microplasma RF Peel</strong>: resurfaces + tightens;
                expect 48 hrs redness.
              </li>
              <li data-id="element-550">
                <strong data-id="element-551">ALMA CO2</strong>: full skin resurfacing +{' '}
                <strong data-id="element-552">Femilift</strong> (vaginal rejuvenation).
                <ul className="list-disc pl-5 mt-2 space-y-2" data-id="element-553">
                  <li data-id="element-554">Requires numbing; 1–2 weeks downtime.</li>
                  <li data-id="element-555">Done with a trusted colleague nearby.</li>
                </ul>
              </li>
            </ul>
          </div>
        </section>
      </main>
    </div>;
}